import { Component, OnInit } from '@angular/core';

import { navItems } from '../../_nav';
import { AuthService } from '../../services/auth/auth.service';
import { Router } from '@angular/router';
import { AppStateService } from '../../services/appState/app-state.service';
import { getUserData } from '../../util/manageUserData';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
})
export class DefaultLayoutComponent implements OnInit {
  minimized = false;
  locations = [];
  public navItems = [...navItems];

  status: { isOpen: boolean } = { isOpen: false };
  disabled: boolean = false;
  isDropup: boolean = true;
  autoClose: boolean = false;
  selectedLocation = 'Select Location';

  constructor(
    private serviceAuth: AuthService,
    private router: Router,
    private serviceAppState: AppStateService,
  ) {}

  ngOnInit() {
    this.locations = this.getStoreLocations();
    localStorage.setItem('selectedLocation', JSON.stringify(this.locations[0]));
    document.getElementById('button-basic').innerHTML =
      this.locations[0]['text'];
  }

  onHidden(): void {}
  onShown(): void {}
  isOpenChange(): void {}

  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isOpen = !this.status.isOpen;
  }

  change(value: boolean): void {
    this.status.isOpen = value;
  }

  toggleMinimize(e) {
    this.minimized = e;
  }

  logOutUser() {
    let status = this.serviceAuth.logOutUser();
    this.router.navigateByUrl('/login');
  }

  getStoreLocations() {
    let storageData = getUserData();
    return storageData['store_detail_dictionary']['store_details_array'];
  }

  updateLocation(data) {
    // let textValue = $event.target.selectedOptions[0]['label'];
    //
    //
    // let selectedLocation = {"id":id, "text":textValue}
    localStorage.removeItem('selectedLocation');
    localStorage.setItem('selectedLocation', JSON.stringify(data));
    document.getElementById('button-basic').innerHTML = data.text;
    this.serviceAppState.changeMessage(data.id);
  }
}
